import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IModelForUpdateCustomer, IUserProfile} from "../../models/Auth";

interface IUserProfileSliceState {
    isAuthorized: boolean | null,
    profile: IUserProfile | null
}

const initialState: IUserProfileSliceState = {
    isAuthorized: null,
    profile: null
}

const profileSlice = createSlice({
    name: "profileSlice",
    initialState,
    reducers: {
        login: (state, action: PayloadAction<IUserProfile>) => {
            state.isAuthorized = true;
            state.profile = action.payload;
        },
        logout: (state) => {
            state.isAuthorized = false;
            state.profile = null;
        },
        updateProfileAction: (state, action: PayloadAction<IModelForUpdateCustomer>) => {
            if (state.profile) {
                if (action.payload.profileImage) {
                    state.profile.profileImage = action.payload.profileImage;
                }
                state.profile.dateOfBirth = action.payload.dateOfBirth;
                state.profile.phone = action.payload.phone;

            }


        }
    }
});

export const {login, logout, updateProfileAction} = profileSlice.actions;

export default profileSlice.reducer;